import { render, staticRenderFns } from "./HolidayPlusRooms.vue?vue&type=template&id=2111eece"
import script from "./HolidayPlusRooms.vue?vue&type=script&lang=js"
export * from "./HolidayPlusRooms.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusRooms.vue?vue&type=style&index=0&id=2111eece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports